

import React from 'react';
import {
  Button, Col, Modal, Row, Spin, Form, Input, Card,
} from 'antd';
import { faFileImage } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box, ShowIf, Text,
} from '../../../shared/components';
import VerticalBox from '../../../shared/components/basic/VerticalBox';

class EditDocumentModal extends React.Component {
  state = { modalVisible: false };

  close() {
    this.setState({ modalVisible: false });
  }

  open() {
    this.setState({ modalVisible: true });
  }

  setFileToEdit(file) {
    const { nombre } = file;
    const extension = nombre.substr(nombre.lastIndexOf('.'));
    const nombreSinExtension = nombre.replace(extension, '');
    this.setState({ fileToEdit: { ...file, nombre: nombreSinExtension }, extension });
  }

  onGuardarDocumento() {
    const { onGuardarDocumento } = this.props;
    const { fileToEdit, extension } = this.state;
    const { nombre } = fileToEdit;
    onGuardarDocumento({
      ...fileToEdit,
      nombre: `${nombre}${extension}`,
    });
  }

  render() {
    const { loading } = this.props;
    const { modalVisible } = this.state;
    const { fileToEdit } = this.state;
    if (fileToEdit === null || fileToEdit === undefined) {
      return null;
    }

    const {
      fileToEdit: {
        nombre, descripcion, publicUrl, esImagen,
      },
    } = this.state;

    const sePuedePrevisualizar = esImagen === true;

    return (
      <Modal
        title={(
          <Text fontSize="16" fontWeight="semibold">
            Documento:
            {nombre}
          </Text>
        )}
        visible={modalVisible}
        onCancel={() => this.close()}
        footer={(
          <Box>
            <Button onClick={() => this.close()}>Cancelar</Button>
            <Button disabled={nombre.length === 0} type="primary" onClick={() => this.onGuardarDocumento() }>Guardar</Button>
          </Box>
        )}
      >
        <Spin spinning={loading}>
          <Row gutter={16}>
            <Col span={12}>
              <Card style={{ background: '#F5F5F5' }}>
                <VerticalBox height="180px" style={{ textAlign: 'center'}}>
                  <Box>
                    <ShowIf condition={sePuedePrevisualizar !== true}>
                      <FontAwesomeIcon icon={faFileImage} size="3x" color="lightgrey" />
                      <Text mt="8" color="lightgray">Previsualización no disponible</Text>
                    </ShowIf>
                    <ShowIf condition={sePuedePrevisualizar === true}>
                      <img alt="" src={publicUrl} width="100%" height="100%" />
                    </ShowIf>
                  </Box>
                </VerticalBox>
              </Card>
            </Col>
            <Col span={12}>
              <Form>
                <Form.Item label="Nombre">
                  <Input value={nombre} onChange={e => this.setState({ fileToEdit: { ...fileToEdit, nombre: e.target.value } })} />
                </Form.Item>
                <Form.Item label="Descripcion">
                  <Input.TextArea rows={8} value={descripcion} onChange={e => this.setState({ fileToEdit: { ...fileToEdit, descripcion: e.target.value } })} />
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Spin>
      </Modal>
    );
  }
}

export default EditDocumentModal;
